export const utmForwarding = function ({ expireMinutes }) {
	let current = {
		state: document.location.href,
		query: document.location.search.substring(1),
		time: new Date().getTime(),
	};

	let storage = {
		area: window.localStorage,
		key: 'last_utm_query',
	};

	const expiryTime = expireMinutes * 60 * 1000;

	if (/utm_/.test(current.query)) {
		// exclude specific params from being saved
		const excludedParams = ['calcTimeSavings', 'calcCostSavings', '_sp'];

		const filteredQuery = current.query
			.split('&')
			.filter((param) => {
				const paramName = param.split('=')[0];
				return !excludedParams.includes(paramName);
			})
			.join('&');

		// save the query string to local storage for later restoration
		storage.area[storage.key] = JSON.stringify({
			time: current.time,
			query: filteredQuery,
		});
	} else if (storage.area[storage.key]) {
		const restored = JSON.parse(storage.area[storage.key]);
		const updated = {};

		// if within expiry time, restore the query string
		if (current.time - restored.time <= expiryTime) {
			updated.state = document.createElement('a');
			updated.state.href = current.state;

			updated.state.search +=
				(updated.state.search ? '&' : '') + restored.query;

			typeof window !== 'undefined' &&
				window.history.replaceState('', {}, updated.state);
		} else {
			// if expired, remove the query string from local storage
			storage.area.removeItem(storage.key);
		}
	}
};
